import { render, staticRenderFns } from "./ExamAdd.vue?vue&type=template&id=2cfce927&"
import script from "./ExamAdd.vue?vue&type=script&lang=js&"
export * from "./ExamAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports